<template>
<div>待开发2</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {

    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/mbd/mbs.vue